import { isNil } from 'lodash';

export const shouldIgnoreExpr = (value: unknown) => isNil(value) || Number(value as string) <= 0;
